export function getFaqs() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/FAQ/GetFAQContent', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function getPage() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/Pages/GetPageContentByName/FAQs', {
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json; charset=utf-8',
                      'access-control-allow-origin': '*',
                      'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }
                  })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                    })
            )
        ), 0)
}